import React, { useState } from 'react';
import { IconStar } from '../../../ui/icons';

const TrustedCard = props => {
  const { header, content, reviewImgUrl, revierCompany, revierInfo } = props;

  return (
    <div className="my-shadow rounded-[5px] flex flex-col justify-between ">
      <div className="flex flex-col gap-[10px]">
        <div className="flex gap-2">
          <IconStar />
          <IconStar />
          <IconStar />
          <IconStar />
          <IconStar />
        </div>

        <p className={'text-black font-[700] leading-[20px] text-[18px]'}>{header}</p>
        <p className={'leading-[20px] text-[16px] mt-[14px] font-[400]'}> {content}</p>
      </div>
      <div className={'flex justify-between mt-[32px]'}>
        <div className="flex justify-start items-center ">
          <img src={reviewImgUrl} width={44} height={44} alt="review1" />
          <div className={'ml-[24px] flex flex-col gap-[8px]'}>
            <p className={'text-black text-[14px] font-[400] leading-[17px]'}>{revierInfo}</p>
            <p className={'text-[12px] font-[400] leading-[15px] text-purple capitalize'}>{revierCompany}</p>
          </div>
        </div>
        <a aria-label="view more" href="https://clutch.co/profile/weprodigi-agency?page=1#reviews" target={'_blank'}>
          <span className={'hidden'}>View More</span>
          <img src="https://weprodigi.com/uploads/images/home-page/clutch.svg" className="max-h-[45px]" alt="clutch" />
        </a>
      </div>
    </div>
  );
};

export default TrustedCard;
